import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import addattendance from "./../../containers/Attendance/Add/index";
import viewattendance from "./../../containers/Attendance/View/index";
import AttendanceDetails from "../../containers/Attendance/View/AttendanceDetails";

const Components = ({match}) => (
  <Switch>
    <Redirect exact from={`${match.url}/`} to={`${match.url}/view`}/>
    <Route path={`${match.url}/add`} component={addattendance}/>
    <Route path={`${match.url}/view`} component={viewattendance}/>
    <Route path={`${match.url}/viewDetail/:id`} component={AttendanceDetails}/>
  </Switch>
);

export default Components;